/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
import Select from 'react-select';
import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import closesquare from '../../../images/CloseSquare.png';
import CredentialTable from './credentialTable';
import Urls from '../../../utils/urls';
import '../../../css/apicredential.css';
import ApiRequests from '../../../utils/RequestBody';
import { prefixPath } from '../../../utils/helpers';
import BaseUrls from '../../../utils/baseUrls';
import apiBackendInstance from '../../../utils/axios';
import { subscriptionItem } from '../subscription/subscription';

interface network {
  id: number | string,
  name: string,
  workspaceId: number | string,
  protocolName: string,
  activeNodes: number | string,
  inactiveNodes: number | string,
  frontend_base_suburl: string
}
interface listData {
  id: number | string,
  workid: number | string,
  label: string,
  value: string,
}

export interface cli {
  name: string,
  accesskey: string | number,
}
interface reqBodyPermission {
  resourceName: string | number,
  actions: string[],
  resourceID?: number | string,
}
interface gatewayInterface {
  ipfsClusterID: string,
  ipfsClusterName: string,
  ipfsClusterPublicID: string,
  ipfsClusterType: string
}

interface accessObjType {
  accessKey: string,
  accessSecret: string,
  accessToken?: string
}

const ApiCredential = () => {
  const allNetworkList: network[] = [] as network[];
  const [networkList, setNetworkList] = useState([] as listData[] | []);
  const [selectedOption, setSelectedOption] = useState([] as any);
  const [selectedPermissions, setSelectedPermissions] = useState([] as any);
  const [zdfsDataPermission, setZdfsDataPermission] = useState([] as string[]);
  const [zdfsPinPermission, setZdfsPinPermission] = useState([] as string[]);
  const [zdfsTypeAll, setZdfsTypeAll] = useState(false);
  const [networkType, setNetworkType] = useState(true);
  const [refresh, setRefresh] = useState(true);
  const [name, setName] = useState('');
  const [tableData, setTableData] = useState([] as cli[]);
  const [showAdvance1, setShowAdvance1] = useState<boolean>(false);
  const [showAdvance2, setShowAdvance2] = useState<boolean>(false);
  const [gatewayType, setGatewayType] = useState('sharedgateway');
  const [publicId, setPublicId] = useState<any>();
  const [gatewayList, setGatewayList] = useState([] as { label: string, value: string }[]);
  const [zdfsSubscription, setZdfsSubscription] = useState(false);
  const [showDownload, setShowDownLoad] = useState(false);
  const [accessObj, setAccessObj] = useState({} as accessObjType);

  const actionList = ['read_network', 'edit_network', 'delete_network', 'add_node', 'share_network', 'run_pipelines', 'view_pipelines', 'node.*'];
  const actionZDFSList = [
    ['uploadFile',
      'uploadCID',
      'unpinByFileID',
      'editFileByFIleID',
      'fileList',
      'viewFileByFileID',
      'pinbyfileid',
      'deletebyfileids',
    ],
    ['addPinObject',
      'getPinObject',
      'listPinObjects',
      'replacePinObject',
      'removePinObject',
    ],
  ];

  const handleOnChange = (position: number, zdfsActionType: number, zdfsResourceType: string) => {
    if (zdfsResourceType === 'all') {
      if (zdfsTypeAll) {
        setZdfsTypeAll(false);
      } else {
        hideAdvanceTab(1);
        hideAdvanceTab(2);
        setZdfsTypeAll(true);
      }
      return;
    }
    if (zdfsTypeAll) {
      setZdfsTypeAll(false);
    }
    const val = actionZDFSList[zdfsActionType][position].toLowerCase();

    const tmpArr = zdfsResourceType === 'data' ? zdfsDataPermission : zdfsPinPermission;
    if (tmpArr.length === 0) {
      tmpArr.push(val);
    } else if (tmpArr.includes(val)) {
      const index = tmpArr.indexOf(val);
      if (index > -1) {
        tmpArr.splice(index, 1);
      }
    } else {
      tmpArr.push(val);
    }
    if (zdfsResourceType === 'data') {
      setZdfsDataPermission(tmpArr);
    } else {
      setZdfsPinPermission(tmpArr);
    }
  };
  const PermissionArray = [
    { id: 1, label: actionList[0], value: actionList[0] },
    { id: 2, label: actionList[1], value: actionList[1] },
    { id: 3, label: actionList[2], value: actionList[2] },
    { id: 4, label: actionList[3], value: actionList[3] },
    { id: 5, label: actionList[4], value: actionList[4] },
    { id: 6, label: actionList[5], value: actionList[5] },
    { id: 7, label: actionList[6], value: actionList[6] },
    { id: 7, label: actionList[7], value: actionList[7] },

  ];
  const fetchGatewayList = () => {
    apiBackendInstance.get(Urls.getGatewayList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data.list) {
        const myArrayFiltered = response.data.data.list.filter((x: gatewayInterface) => x.ipfsClusterType === 'dedicated');
        const prepareArr: { label: string, value: string }[] = [];
        if (myArrayFiltered) {
          myArrayFiltered.forEach((element: gatewayInterface) => {
            const obj = { value: element.ipfsClusterID, label: element.ipfsClusterName };
            prepareArr.push(obj);
          });
        }
        setGatewayList(prepareArr);
      }
      hideLoader();
    })
      .catch((err) => {
        console.error('err getting gateway list', err);
        setGatewayList([]);
      });
  };
  const getCliList = () => {
    apiBackendInstance.get(Urls.getCliApiList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response && response.data) {
          setTableData(response.data.data);
          hideLoader();
        }
      })
      .catch((err) => {
        console.error('err getting api cli list', err);
        setTableData([]);
      });
  };
  const getNetworkList = () => {
    apiBackendInstance.get(Urls.getAllNetworkList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        const re = response.data.data as network[];
        allNetworkList.push(...re);
        const arr: listData[] = [];
        for (let i = 0; i < allNetworkList.length; i += 1) {
          const x = allNetworkList[i].id;
          const y = allNetworkList[i].name;
          const WorkId = allNetworkList[i].workspaceId;
          const z: listData = {
            id: nanoid(), workid: WorkId.toString(), label: y, value: x.toString(),
          };
          arr.push(z);
        }
        setNetworkList(arr);
      }
    }).catch(() => {
      setNetworkList([]);
    });
  };

  const getZdfsSubscription = () => {
    apiBackendInstance.get(Urls.getSubscriptionSummary(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        const subItem = response.data.data.filter((e: subscriptionItem) => e.protocol_name.toLowerCase() === 'zdfs');
        if (subItem[0] && subItem[0].subscription_details && subItem[0].subscription_details.plan.total_quantity > 0) {
          setZdfsSubscription(true);
        }
      }
      hideLoader();
    }).catch((e) => {
      console.error(e);
      hideLoader();
    });
  };
  useEffect(() => {
    showLoader();
    fetchGatewayList();
    getZdfsSubscription();
    getCliList();
    getNetworkList();
  }, []);

  useEffect(() => {
    getCliList();
    setNetworkType(true);
  }, [refresh]);

  const imgSubPath = window.location.origin;
  const theme = BaseUrls.getkey();

  const showLoader = () => {
    const spinnerDiv = document.getElementById('spinnerDiv2');
    if (spinnerDiv) spinnerDiv.style.display = 'block';
  };

  const hideLoader = () => {
    const spinnerDiv = document.getElementById('spinnerDiv2');
    if (spinnerDiv) spinnerDiv.style.display = 'none';
  };

  const spinner = imgSubPath + prefixPath(`/img/${theme}/spin.svg`);

  const resetModal = () => {
    setName('');
    setNetworkType(true);
    setZdfsDataPermission([]);
    setZdfsPinPermission([]);
    setSelectedOption([]);
    setSelectedPermissions([]);
  };

  const Submit = () => {
    if (!validateNetwork()) {
      return;
    }
    if (!validateZdfs()) {
      return;
    }
    const createBtn: any = document.getElementById('createBtn');
    if (createBtn) {
      createBtn.disabled = true;
    }
    showLoader();
    const allPermissions = [];
    for (let i = 0; i < selectedPermissions.length; i += 1) {
      allPermissions.push(selectedPermissions[i].value);
    }
    const permissions: reqBodyPermission[] = [];
    if (!networkType) {
      if (zdfsTypeAll) {
        const obj: reqBodyPermission = {
          resourceName: `zdfs.${gatewayType}`,
          actions: ['data.*', 'psa.*'],
          resourceID: gatewayType === 'sharedgateway' ? '' : publicId.value,
        };
        permissions.push(obj);
      } else {
        if (zdfsDataPermission.length > 0) {
          const obj: reqBodyPermission = {
            resourceName: `zdfs.${gatewayType}.data`,
            actions: zdfsDataPermission,
            resourceID: gatewayType === 'sharedgateway' ? '' : publicId.value,

          };
          permissions.push(obj);
        }
        if (zdfsPinPermission.length > 0) {
          const obj: reqBodyPermission = {
            resourceName: `zdfs.${gatewayType}.psa`,
            actions: zdfsPinPermission,
            resourceID: gatewayType === 'sharedgateway' ? '' : publicId.value,

          };
          permissions.push(obj);
        }
      }
    }
    if (networkType) {
      for (let i = 0; i < selectedOption.length; i += 1) {
        const obj: reqBodyPermission = {
          resourceName: 'Workspace.Network',
          actions: allPermissions,
          resourceID: selectedOption[i].value,
        };
        permissions.push(obj);
      }
    }

    apiBackendInstance.put(Urls.createApiCredURl(),
      {
        data: ApiRequests.createApiCredBody(
          name, !networkType, permissions,
        ),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        timeout: 5000,
      }).then((response) => {
      const { data } = response;
      if (data && data.data && (data.data.Success || data.data.success)) {
        const ptag: HTMLElement | null = document.getElementById('showSuccess');
        setRefresh(!refresh);
        setShowDownLoad(true);
        if (ptag) {
          ptag.style.display = 'block';
          if (data.data.credentials.access_token !== null && data.data.credentials.access_token) {
            setAccessObj(
              {
                accessKey: data.data.credentials.accesskey,
                accessSecret: data.data.credentials.accesssecret,
                accessToken: data.data.credentials.access_token,
              },
            );
            ptag.innerHTML = `AccessKey : ${data.data.credentials.accesskey} <br> AccessSecret: ${data.data.credentials.accesssecret}   <br> AccessToken: ${data.data.credentials.access_token}`;
          } else {
            setAccessObj(
              {
                accessKey: data.data.credentials.accesskey,
                accessSecret: data.data.credentials.accesssecret,
                accessToken: '-',
              },
            );
            ptag.innerHTML = `AccessKey : ${data.data.credentials.accesskey} <br> AccessSecret: ${data.data.credentials.accesssecret}`;
          }
        }
      }
      if (createBtn) {
        createBtn.disabled = false;
      }
      hideLoader();
    }).catch((err) => {
      console.error(err);
      const ptag: HTMLElement | null = document.getElementById('showResponse');
      if (ptag) {
        ptag.style.display = 'block';
        ptag.innerHTML = 'Error creating access key ';
      }
      if (createBtn) {
        createBtn.disabled = false;
      }
      hideLoader();
    });
  };

  const hideModal = () => {
    const ptag: HTMLElement | null = document.getElementById('showResponse');
    if (ptag) {
      ptag.style.display = 'none';
    }
    const ptag2: HTMLElement | null = document.getElementById('showSuccess');
    if (ptag2) {
      ptag2.style.display = 'none';
    }
    resetModal();
  };

  const showMessage = (msg: string) => {
    const ptag: HTMLElement | null = document.getElementById('showResponse');
    if (ptag) {
      ptag.innerHTML = msg;
      ptag.style.display = 'block';
    }
  };

  const validateNetwork = () => {
    if (!networkType) {
      return true;
    }
    if (!name || name.length < 1) {
      showMessage('Please fill key name');
      return false;
    }
    if (!selectedOption || selectedOption.length === 0) {
      showMessage('Please select network');
      return false;
    }
    if (!selectedPermissions || selectedPermissions.length === 0) {
      showMessage('Please select permission');
      return false;
    }
    return true;
  };

  const validateZdfs = () => {
    if (networkType) {
      return true;
    }
    if (!name || name.length < 1) {
      showMessage('Please fill key name');
      return false;
    }
    if (gatewayType === 'dedicatedgateway' && !publicId) {
      showMessage('Please select dedicated gateway');
      return false;
    }
    if (zdfsTypeAll) {
      return true;
    }
    if (!zdfsTypeAll && zdfsDataPermission.length === 0 && zdfsPinPermission.length === 0) {
      showMessage('Please select permission');
      return false;
    }
    return true;
  };

  const showAdvanceTab = (cno: number) => {
    const advanceTab = document.getElementById(`advance-tab-${cno}`);
    if (advanceTab) {
      advanceTab.style.display = 'flex';
      if (cno === 1) {
        setShowAdvance1(!showAdvance1);
      } else {
        setShowAdvance2(!showAdvance2);
      }
    }
  };

  const hideAdvanceTab = (cno: number) => {
    const advanceTab = document.getElementById(`advance-tab-${cno}`);
    if (advanceTab) {
      advanceTab.style.display = 'none';
      if (cno === 1) {
        setShowAdvance1(!showAdvance1);
      } else {
        setShowAdvance2(!showAdvance2);
      }
    }
  };

  function export2txt() {
    const downloadData = {
      accessTokken: accessObj.accessToken,
      accessKey: accessObj.accessKey,
      accessSecret: accessObj.accessSecret || '-',
    };

    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([JSON.stringify(downloadData, null, 2)], {
      type: 'text/plain',
    }));
    a.setAttribute('download', `${name}.txt`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    hideModal();
  }
  return (
    <div
      className="tab-pane fade show active "
      id="profile"
    >
      <div className="col-xl-11 col-lg-12 col-sm-12 col-md-12">
        <div className="text-end mt-3">
          <button
            type="button"
            className="btn comingSoon"
            data-bs-toggle="modal"
            data-bs-target="#createkey"
          >
            Create Key
          </button>
        </div>
        {/* Modal */}
        <div
          className="modal fade"
          id="createkey"
          tabIndex={-1}
          aria-labelledby="createkeyapi"
          aria-hidden="true"
          style={{ color: 'black' }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered text-black">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="createkeyapi">
                  Create Access Key
                </h5>
                <img className="cursor" src={closesquare} data-bs-dismiss="modal" onClick={() => { hideModal(); }} alt="" />
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3 col-10 mb-4 mx-auto">
                    <h6 className="col-10  mb-3 mt-3">
                      Key Name
                    </h6>
                    <input type="text" style={{ width: '500px' }} className="form-control text-black" value={name} placeholder="Key Name" onChange={(e) => { setName(e.target.value); }} />
                  </div>
                  <div className="mb-3 col-10 mb-4 mx-auto">
                    <h6 className="col-10  mb-3 mt-3">
                      Service Type
                    </h6>
                  </div>
                  <div className="row mt-4 radioleft">
                    <div className="form-check mx-5 col-xl-3 col-lg-5 col-lg-6 col-sm-12">
                      <input
                        className="form-check-input ms-1"
                        type="radio"
                        name="flexRadioDefault15"
                        id="z21"
                        value="true"
                        checked={networkType}
                        onClick={() => { setNetworkType(true); }}
                      />
                      <label className="form-check-label mx-2" htmlFor="flexRadioDefault15">
                        Network
                      </label>
                    </div>
                    <div className="form-check col-xl-6 col-lg-5 col-lg-6 col-sm-12">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="flexRadioDefault15"
                        value="false"
                        checked={!networkType}
                        disabled={BaseUrls.getkey() !== 'zeeve'}
                        onClick={() => { setNetworkType(false); }}
                      />
                      <label
                        className="form-check-label mx-2"
                        htmlFor="flexRadioDefault15"
                      >
                        ZDFS
                      </label>
                    </div>
                  </div>
                  <div id="spinnerDiv2" className="col-10 text-center mx-3" style={{ position: 'absolute', display: 'none', zIndex: 10 }}>
                <img className="mx-5" src={spinner} alt="spinnner" />
                  </div>
                  {
                    !networkType && !zdfsSubscription && (
                      <div>
                        <div className="alert alert-danger mt-5 mb-5 mx-5 col-10" style={{ textAlign: 'center' }} role="alert">
                          <a href={`${Urls.getZvaultUrl()}/purchase-subscription`} className="mx-2">Please buy zdfs subscription before creating access key.</a>
                        </div>
                      </div>
                    )
                  }
                  {!networkType && zdfsSubscription && (
                    <>
                      <div className="mb-3 col-10 mb-4 mx-auto">
                        <h6 className="col-10  mb-3 mt-3">
                          Gateway Type
                        </h6>
                      </div>
                      <div className="row mt-4 radioleft">
                        <div className="form-check mx-5 col-xl-3 col-lg-5 col-lg-6 col-sm-12">
                          <input
                            className="form-check-input ms-1"
                            type="radio"
                            name="gateway-radio"
                            id="z21"
                            value="sharedgateway"
                            checked={gatewayType === 'sharedgateway'}
                            onClick={() => { setGatewayType('sharedgateway'); }}
                          />
                          <label className="form-check-label mx-2" htmlFor="gateway-radio">
                            Shared Gateway
                          </label>
                        </div>
                        <div className="form-check col-xl-6 col-lg-5 col-lg-6 col-sm-12">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="gateway-radio"
                            value="dedicatedgateway"
                            checked={gatewayType !== 'sharedgateway'}
                            onClick={() => { setGatewayType('dedicatedgateway'); }}
                          />
                          <label
                            className="form-check-label mx-2"
                            htmlFor="gateway-radio"
                          >
                            Dedicated Gateway
                          </label>
                        </div>
                      </div>
                    </>
                  )}
                  {!networkType && zdfsSubscription && gatewayType === 'dedicatedgateway' && (
                    <div className="mb-3 col-10 mb-4 mx-auto">
                      <h6 className="col-10 mb-3 mt-3">
                        Select Gateway
                      </h6>
                      <div style={{ width: '500px', marginLeft: '0px' }}>
                        <Select
                          name="colors"
                          options={gatewayList}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={setPublicId}
                        />
                      </div>
                    </div>
                  )}
                  {networkType && (
                    <div className="mb-3 col-10 mb-4 mx-auto">
                      <h6 className="col-10 mb-3 mt-3">
                        Select Networks
                      </h6>
                      <div id="spinnerDiv" className="col-8 text-center mx-3" style={{ position: 'absolute', display: 'none', zIndex: 10 }}>
                        <img className="mx-5" src={spinner} alt="spinnner" />
                      </div>
                      <div style={{ width: '500px', marginLeft: '0px' }}>
                        <Select
                          isMulti
                          name="colors"
                          options={networkList}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={setSelectedOption}
                        />
                      </div>
                    </div>
                  )}
                  {networkType && (
                    <div className="mb-3 col-10 mb-4 mx-auto ">
                      <h6 className="col-10 mb-3 mt-3">
                        Select Permissions
                      </h6>
                      <div style={{ width: '500px', marginLeft: '0px' }}>
                        <Select
                          isMulti
                          name="permissionSelect"
                          options={PermissionArray}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={setSelectedPermissions}
                        />
                      </div>
                    </div>
                  )}
                  {!networkType && zdfsSubscription && (
                    <div className="col-10 mb-3 mt-4 mx-auto">
                      <h6 className="col-10 mb-3 mt-3">Permissions</h6>
                      <div className="mt-2  col-10 mx-3">
                        <div className="row mt-3 ms-2">
                          <div className="form-check col-xl-3 col-lg-3 col-sm-6 mb-1 col-md-3 RPCspace1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="Select All"
                              value="Select All"
                              checked={zdfsTypeAll}
                              onChange={() => handleOnChange(0, 0, 'all')}
                            />
                            <label className="form-check-label mx-2" htmlFor={`custom-data-checkbox-${0}`}>Select All</label>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3  col-11 mx-3">
                        <div className="row">
                          <span className="col-10"><strong>Data APIs</strong></span>
                          <div className="col-xl-1 col-sm-2 col-lg-1 col-md-2 cursor" style={{ width: 'fit-content' }}>
                            {showAdvance1 && (
                              <i
                                className="fa-solid fa-chevron-up mx-3"
                                onClick={() => {
                                  hideAdvanceTab(1);
                                }}
                                style={{ fontSize: '15px' }}
                              />
                            )}
                            {!showAdvance1 && (
                              <i
                                className="fa-solid fa-chevron-down mx-3"
                                onClick={() => {
                                  showAdvanceTab(1);
                                }}
                                style={{ fontSize: '15px', marginTop: '-15px' }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="row mt-3 ms-2" id="advance-tab-1" style={{ display: showAdvance1 ? 'flex' : 'none' }}>
                          {actionZDFSList[0].map((d, idx) => (
                            <div key={`custom-checkbox-apis-${idx.toString()}`} className="form-check col-xl-3 col-lg-3 col-sm-6 mb-3 col-md-3 RPCspace1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`custom-data-checkbox-${idx}`}
                                name={d}
                                value={d}
                                onChange={() => handleOnChange(idx, 0, 'data')}
                              />
                              <label className="form-check-label mx-2" htmlFor={`custom-data-checkbox-${idx}`}>{d}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="mt-3 col-11 mx-3">
                        <div className="row">
                          <span className="col-10"><strong>Pinned Service APIs</strong></span>
                          <div className="col-xl-1 col-sm-2 col-lg-1 col-md-2 cursor" style={{ width: 'fit-content' }}>
                            {showAdvance2 && (
                              <i
                                className="fa-solid fa-chevron-up mx-3"
                                onClick={() => {
                                  hideAdvanceTab(2);
                                }}
                                style={{ fontSize: '15px' }}
                              />
                            )}
                            {!showAdvance2 && (
                              <i
                                className="fa-solid fa-chevron-down mx-3"
                                onClick={() => {
                                  showAdvanceTab(2);
                                }}
                                style={{ fontSize: '15px', marginTop: '-15px' }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="row mt-3 ms-2" id="advance-tab-2" style={{ display: showAdvance2 ? 'flex' : 'none' }}>
                          {actionZDFSList[1].map((d, idx) => (
                            <div key={`custom-checkbox-apis-pin-${idx.toString()}`} className="form-check col-xl-3 col-lg-3 col-sm-6 mb-3 col-md-3 RPCspace1">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`custom-pin-checkbox-${idx}`}
                                name={d}
                                value={d}
                                onChange={() => handleOnChange(idx, 1, 'pin')}
                              />
                              <label className="form-check-label mx-2 px-1" htmlFor={`custom-pin-checkbox-${idx}`}>{d}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
              <div className="modal-footer col-12">
                <div className="">
                  <button
                    type="button"
                    className="btn btn-secondary mx-1"
                    data-bs-dismiss="modal"
                    onClick={() => { hideModal(); }}
                  >
                    Close
                  </button>
                  {showDownload
                    && (
                      <button
                        type="button"
                        className="btn btn-primary mx-1"
                        data-bs-dismiss="modal"
                        onClick={() => { export2txt(); }}
                      >
                        Download
                      </button>
                    )}
                  <button type="button" id="createBtn" className="btn comingSoon" onClick={() => { Submit(); }}>
                    Create Key
                  </button>
                </div>
              </div>
              <div id="showResponse" className="alert alert-danger mt-3 mb-5 mx-5" style={{ display: 'none', textAlign: 'center' }} role="alert">Response</div>
              <div id="showSuccess" className="alert alert-success mt-3 mb-5 mx-5" style={{ display: 'none', textAlign: 'center', overflowWrap: 'anywhere' }} role="alert">Response</div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-11 mt-2 col-lg-12 col-sm-12 col-md-12">
        <CredentialTable entires={tableData} refreshCliList={getCliList} />
      </div>
    </div>

  );
};
export default ApiCredential;
